import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  useTheme,
  Stack,
} from "@mui/material";
import { Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "sm");
  return (
    <Dialog open={open} onClose={onCancel}>
      <Stack sx={{ alignItems: isMobile ? "center" : "-moz-initial" }}>
        {title && (
          <DialogTitle sx={{ fontFamily: "Work Sans" }}>{title}</DialogTitle>
        )}
        <DialogContent>
          <Typography sx={{ fontFamily: "Work Sans" }}>{message}</Typography>
        </DialogContent>
        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={2}
          sx={{ p: 2, width: "100%" }}
        >
          <Button
            onClick={onCancel}
            sx={{ color: theme.palette.common.black, fontFamily: "Work Sans" }}
          >
            {Strings.button.no}
          </Button>

          <Button
            onClick={onConfirm}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
              fontFamily: "Work Sans",
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            {Strings.button.yes}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export { ConfirmDialog };
